import { createFileRoute } from "@tanstack/react-router";
import { NodesPage } from "@/features/me/NodesPage";

export const Route = createFileRoute("/app/me/nodes")({ component: NodesPage });
